import { render } from "./Ai247InstanceRail.vue?vue&type=template&id=06ec2f94&scoped=true&ts=true"
import script from "./Ai247InstanceRail.vue?vue&type=script&lang=ts"
export * from "./Ai247InstanceRail.vue?vue&type=script&lang=ts"

import "./Ai247InstanceRail.vue?vue&type=style&index=0&id=06ec2f94&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ec2f94"]])

export default __exports__